var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import styled from "styled-components";
import { Subtitle } from "../../designSystem";
import colors from "../../designSystem/colors";
import theme from "../../designSystem/theme";
var PaginationContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    switch (props.variant) {
        case "buttonLeft":
            return "\n          & :nth-child(1) {\n            order: 1;\n          }\n\n          & :nth-child(2) {\n            order: 3;\n          }\n\n          & :nth-child(3) {\n            order: 4;\n          }\n\n          & :nth-child(4) {\n            order: 5;\n          }\n\n          & :nth-child(5) {\n            order: 2;\n            margin-left: 16px;\n          }\n        ";
    }
    return "";
});
var ArrowButton = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #043F3D;\n  width: 36px;\n  height: 36px;\n  border: 1px solid rgba(226,248,241,0.5);\n  transition: opacity 100ms ease-in;\n  z-index: 1;\n\n  ", "\n\n  i {\n    color: white;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #043F3D;\n  width: 36px;\n  height: 36px;\n  border: 1px solid rgba(226,248,241,0.5);\n  transition: opacity 100ms ease-in;\n  z-index: 1;\n\n  ", "\n\n  i {\n    color: white;\n  }\n"])), function (props) {
    return props.disabled
        ? "\n          opacity: 0.24;\n          cursor: default;\n        "
        : "\n          &:hover {\n            opacity: " + theme.hover.opacity + ";\n          }\n        ";
});
var TotalText = styled(Subtitle)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), colors.text);
var PaginationBar = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: ", "px;\n  height: 2px;\n  background-color: ", ";\n  position: relative;\n"], ["\n  width: ", "px;\n  height: 2px;\n  background-color: ", ";\n  position: relative;\n"])), function (props) { return props.width; }, colors.background.three);
var PaginationChild = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 9px;\n  height: 25px;\n  line-height: 25px;\n  display: inline-block;\n  text-align: center;\n  margin: 0 8px;\n  font-size: 16px;\n  cursor: pointer;\n  color: ", ";\n  border-bottom: ", "\n"], ["\n  width: 9px;\n  height: 25px;\n  line-height: 25px;\n  display: inline-block;\n  text-align: center;\n  margin: 0 8px;\n  font-size: 16px;\n  cursor: pointer;\n  color: ", ";\n  border-bottom: ", "\n"])), function (props) { return props.active ? "#69ECCE" : "#739C97"; }, function (props) { return props.active ? "1px solid #69ECCE" : ""; });
var EllipsisChild = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 9px;\n  height: 25px;\n  line-height: 25px;\n  display: inline-block;\n  text-align: center;\n  margin: 0 8px;\n  font-size: 16px;\n  color: #739C97;\n"], ["\n  width: 9px;\n  height: 25px;\n  line-height: 25px;\n  display: inline-block;\n  text-align: center;\n  margin: 0 8px;\n  font-size: 16px;\n  color: #739C97;\n"])));
var Pagination = function (_a) {
    var page = _a.page, total = _a.total, setPage = _a.setPage, variant = _a.variant, _b = _a.config, _c = _b === void 0 ? {} : _b, _d = _c.paginationBarWidth, paginationBarWidth = _d === void 0 ? 80 : _d, _e = _c.hidePageNumbers, hidePageNumbers = _e === void 0 ? false : _e;
    var PaginationSub = useMemo(function () {
        var arr = [];
        var _loop_1 = function (index) {
            if (index === 1 || index === total) {
                // Show ellipsis for front 
                if (total - page > 3 && index > page + 2) {
                    arr.push(_jsx(EllipsisChild, { children: "..." }, void 0));
                }
                arr.push(_jsx(PaginationChild, __assign({ active: page == index ? true : false, onClick: function () {
                        if (page == index) {
                            return;
                        }
                        setPage(index);
                    } }, { children: index }), index));
                // Show ellipsis for end
                if (page > 3 && index < page - 2) {
                    arr.push(_jsx(EllipsisChild, { children: "..." }, void 0));
                }
                return "continue";
            }
            // Hide Pagination for front 
            if (page > 3 && index < page - 2) {
                return "continue";
            }
            // Hide Pagination for end 
            if (total - page > 3 && index > page + 2) {
                return "continue";
            }
            arr.push(_jsx(PaginationChild, __assign({ active: page == index ? true : false, onClick: function () {
                    if (page == index) {
                        return;
                    }
                    setPage(index);
                } }, { children: index }), index));
        };
        for (var index = 1; index <= total; index++) {
            _loop_1(index);
        }
        return arr;
    }, [total, page]);
    return total > 0 ? (_jsxs(PaginationContainer, __assign({ className: "d-flex w-100 justify-content-center align-items-center", variant: variant }, { children: [_jsx(ArrowButton, __assign({ role: "button", disabled: page <= 1, onClick: function () {
                    if (page <= 1) {
                        return;
                    }
                    setPage(function (page) { return page - 1; });
                } }, { children: _jsx("img", { src: "https://cdn.bttcdn.com/os/rightArrow.png", width: 8, height: 16, style: { transform: "rotate(180deg)" } }, void 0) }), void 0), hidePageNumbers ? (
            // Just for spacing between the arrows
            _jsx("div", { className: "pl-4" }, void 0)) : (_jsx("div", __assign({ style: { margin: '0 30px' } }, { children: PaginationSub }), void 0)), _jsx(ArrowButton, __assign({ role: "button", disabled: page >= total, onClick: function () {
                    if (page >= total) {
                        return;
                    }
                    setPage(function (page) { return page + 1; });
                } }, { children: _jsx("img", { src: "https://cdn.bttcdn.com/os/rightArrow.png", width: 8, height: 16 }, void 0) }), void 0)] }), void 0)) : (_jsx(_Fragment, {}, void 0));
};
export default Pagination;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Pagination.js.map